/* eslint-disable no-unused-vars */
const THREE = window.THREE;
import HttpService from '@/utils/httpService';
import store from '..';
import { log as debugLog, error as debugError } from '@/utils/debugLogger';
import notStartedIcon from '@/images/clock 1.png';
import inProgressIcon from '@/images/work-in-progress 1.png';
import completedIcon from '@/images/check 1.png';
import canceledIcon from '@/images/Canceled.png';
import suspendIcon from '@/images/Suspended.png';
import overdueIcon from '@/images/overdue.png';
import dueIcon from '@/images/due.png';
import { clearThemingColors, setPermeativeElementsTheme } from '@/utils/forgeUtils';
import Vue from 'vue';

export const SisTestingDashboard = {
  state: {
    showSisDashboardFiltersPanel: false,
    showSisTestingDashboard: false,
    updateDashboardStatusTimeout: null,
    dispatchResetSisDashboardGrid: false,

    sisDashboardGridIsLoading: false,
    sisDashboardGridLastRequest: null,

    sisDashboardJobStatusIsLoading: false,
    sisDashboardJobStatusLastRequest: null,
    sisDashboardJobStatus: [
      {
        name: 'Not Started',
        colorClass: 'not-started-color',
        icon: notStartedIcon,
        value: 0,
        isSelected: false,
      },
      {
        name: 'In Progress',
        colorClass: 'inprogress-color',
        icon: inProgressIcon,
        value: 0,
        isSelected: false,
      },
      {
        name: 'Canceled',
        colorClass: 'canceled-color',
        icon: canceledIcon,
        value: 0,
        isSelected: false,
      },
      {
        name: 'Completed',
        colorClass: 'completed-color',
        icon: completedIcon,
        value: 0,
        isSelected: false,
      },
    ],

    sisDashboardActivityStatusIsLoading: false,
    sisDashboardActivityStatusLastRequest: null,
    sisDashboardActivityStatus: [
      {
        name: 'Not Started',
        colorClass: 'not-started-color',
        icon: notStartedIcon,
        value: 0,
        isSelected: false,
      },
      {
        name: 'Due',
        colorClass: 'due-color',
        icon: dueIcon,
        value: 0,
        isSelected: false,
      },
      {
        name: 'Overdue',
        colorClass: 'canceled-color',
        icon: overdueIcon,
        value: 0,
        isSelected: false,
      },
      {
        name: 'In Progress',
        colorClass: 'inprogress-color',
        icon: inProgressIcon,
        value: 0,
        isSelected: false,
      },
      {
        name: 'Suspended',
        colorClass: 'suspend-color',
        icon: suspendIcon,
        value: 0,
        isSelected: false,
      },
      {
        name: 'Completed',
        colorClass: 'completed-color',
        icon: completedIcon,
        value: 0,
        isSelected: false,
      },
    ],

    sisDashboardEquipmentChartIsLoading: false,
    sisDashboardEquipmentChartLastRequest: null,
    sisDashboardEquipmentChart: [
      {
        label: 'Ready',
        color: '#7FC67A',
        value: 0,
        isSelected: true,
      },
      {
        label: 'Not Ready',
        color: '#7E7E7F',
        value: 0,
        isSelected: true,
      },
      {
        label: 'Overdue',
        color: '#D60000',
        value: 0,
        isSelected: true,
      },
    ],

    sisDashboardCauseChartIsLoading: false,
    sisDashboardCauseChartLastRequest: null,
    sisDashboardCauseChart: [
      {
        label: 'Ready',
        color: '#7FC67A',
        value: 0,
        isSelected: true,
      },
      {
        label: 'Not Ready',
        color: '#7E7E7F',
        value: 0,
        isSelected: true,
      },
      {
        label: 'In Progress',
        color: '#FF7B00',
        value: 0,
        isSelected: true,
      },
      {
        label: 'Overdue',
        color: '#D60000',
        value: 0,
        isSelected: true,
      },
    ],

    sisDashboardQueriesChartIsLoading: false,
    sisDashboardQueriesChartLastRequest: null,
    sisDashboardQueriesChart: [
      {
        label: 'Raised',
        color: '#F4CC90',
        border: '#F4CC90',
        value: 0,
        isSelected: true,
      },
      {
        label: 'Answered',
        color: '#F46B11',
        border: '#F46B11',
        value: 0,
        isSelected: true,
      },
      {
        label: 'Closed',
        color: '#80C67C',
        border: '#80C67C',
        value: 0,
        isSelected: true,
      },
    ],

    sisDashboardActivitiesProgressChartIsLoading: false,
    sisDashboardActivitiesProgressChartLastRequest: null,
    sisDashboardActivitiesProgressChart: {
      actualStartDates: [],
      plannedStartDates: [],
      forecastDates: [],
    },

    sisDatagridPropertiesWithCheck: [
      { name: 'Activity No.', isChecked: true },
      { name: 'Progress', isChecked: true },
      { name: 'Tq Count', isChecked: true },
      { name: 'Status', isChecked: true },
      { name: 'Overdue  ( In days )', isChecked: true },
      { name: 'Start', isChecked: true, sortable: true },
      { name: 'End', isChecked: true, sortable: true },
      { name: 'Project  No.', isChecked: true },
      { name: 'Job No.', isChecked: true },
      { name: 'Class', isChecked: true },
      { name: 'Unit', isChecked: true },
      { name: 'Cause Type', isChecked: true },
      { name: 'Discipline', isChecked: true },
    ],
    sisDashboardSelectedDateRangeInDays: 0,
    propertiesFilters: [
      // {
      //     property: 'projectNumber',
      //     display: 'Project No.',
      //     values: []
      // },
      // {
      //     property: 'activityName',
      //     display: 'Activity No.',
      //     values: []
      // },
      {
        property: 'customFieldA',
        display: 'Class',
        values: [],
      },
      {
        property: 'customFieldB',
        display: 'Unit',
        values: [],
      },
      // {
      //     property: 'customFieldC',
      //     display: 'Cause Type',
      //     values: []
      // },
      {
        property: 'dateRange',
        display: 'Date Range',
        values: [
          { value: '12h', inDays: 0.5, isSelected: false },
          { value: '24h', inDays: 1, isSelected: false },
          { value: '48h', inDays: 2, isSelected: false },
          { value: '1 week', inDays: 7, isSelected: false },
          { value: '2 weeks', inDays: 14, isSelected: false },
          { value: '4 weeks', inDays: 28, isSelected: false },
          { value: '8 weeks', inDays: 56, isSelected: false },
          { value: '12 weeks', inDays: 84, isSelected: false },
        ],
      },
      // {
      //     property: 'progress',
      //     display: 'Progress',
      //     values: [
      //         { value: 'Not Started', isSelected: false },
      //         { value: 'Overdue', isSelected: false },
      //         { value: 'Completed', isSelected: false },
      //         { value: 'In Progress', isSelected: false },
      //         { value: 'Canceled', isSelected: false },
      //     ]
      // }
    ],
    selectedFilterProperty: 'dateRange',
    selectedUnits: [],
    selectedClasses: [],
    filterPanelSearchText: '',
    sisChartColors: {
      Ready: '#7FC67A',
      'Not Ready': '#7E7E7F',
      Overdue: '#D60000',
      'In Progress': '#FF7B00',
      Raised: '#F4CC90',
      Answered: '#F46B11',
      Closed: '#80C67C',
    },
  },
  getters: {
    GET_SHOW_SIS_TESTING_DASHBOARD: (state) => {
      return state.showSisTestingDashboard;
    },
    GET_SIS_DATAGRID_PROPERTIES_WITH_CHECK: (state) => {
      return state.sisDatagridPropertiesWithCheck;
    },
    GET_DISPATCH_RESET_SIS_DASHBOARD_GRID: (state) => {
      return state.dispatchResetSisDashboardGrid;
    },
    GET_SHOW_SIS_DASHBOARD_FILTERS_PANEL: (state) => {
      return state.showSisDashboardFiltersPanel;
    },
    GET_SIS_DASHBOARD_PROPERTIES_FILTERS: (state) => {
      return state.propertiesFilters;
    },
    GET_SIS_DASHBOARD_SELECTED_FILTER_PROPERTY: (state) => {
      return state.selectedFilterProperty;
    },
    GET_FILTER_PANEL_SEARCH_TEXT: (state) => {
      return state.filterPanelSearchText;
    },
    GET_SIS_DASHBOARD_JOB_STATUS: (state) => {
      return state.sisDashboardJobStatus;
    },
    GET_SIS_DASHBOARD_SELECTED_JOB_STATUS: (state) => {
      return state.sisDashboardJobStatus.filter((s) => s.isSelected).map((s) => s.name);
    },
    GET_SIS_DASHBOARD_ACTIVITY_STATUS: (state) => {
      return state.sisDashboardActivityStatus;
    },
    GET_SIS_DASHBOARD_SELECTED_ACTIVITY_STATUS: (state) => {
      return state.sisDashboardActivityStatus.filter((s) => s.isSelected).map((s) => s.name);
    },
    GET_SIS_DASHBOARD_EQUIPMENT_CHART: (state) => {
      return state.sisDashboardEquipmentChart;
    },
    GET_SIS_DASHBOARD_SELECTED_EQUIPMENT_STATUS: (state) => {
      return state.sisDashboardEquipmentChart.filter((s) => s.isSelected).map((s) => s.label);
    },
    GET_SIS_DASHBOARD_CAUSE_CHART: (state) => {
      return state.sisDashboardCauseChart;
    },
    GET_SIS_DASHBOARD_SELECTED_CAUSE_STATUS: (state) => {
      return state.sisDashboardCauseChart.filter((s) => s.isSelected).map((s) => s.label);
    },
    GET_SIS_DASHBOARD_QUERIES_CHART: (state) => {
      return state.sisDashboardQueriesChart;
    },
    GET_SIS_DASHBOARD_SELECTED_QUERIES_STATUS: (state) => {
      return state.sisDashboardQueriesChart.filter((s) => s.isSelected).map((s) => s.label);
    },
    GET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART: (state) => {
      return state.sisDashboardActivitiesProgressChart;
    },
    GET_SIS_DASHBOARD_SELECTED_DATE_RANGE_IN_DAYS: (state) => {
      return state.sisDashboardSelectedDateRangeInDays;
    },
    GET_SIS_CHART_COLORS: (state) => {
      return state.sisChartColors;
    },
    GET_SIS_DASHBOARD_SELECTED_UNITS: (state) => {
      return state.selectedUnits;
    },
    GET_SIS_DASHBOARD_SELECTED_CLASSES: (state) => {
      return state.selectedClasses;
    },
    GET_SIS_DASHBOARD_JOB_STATUS_IS_LOADING: (state) => {
      return state.sisDashboardJobStatusIsLoading;
    },
    GET_SIS_DASHBOARD_ACTIVITY_STATUS_IS_LOADING: (state) => {
      return state.sisDashboardActivityStatusIsLoading;
    },
    GET_SIS_DASHBOARD_EQUIPMENT_CHART_IS_LOADING: (state) => {
      return state.sisDashboardEquipmentChartIsLoading;
    },
    GET_SIS_DASHBOARD_CAUSE_CHART_IS_LOADING: (state) => {
      return state.sisDashboardCauseChartIsLoading;
    },
    GET_SIS_DASHBOARD_QUERIES_CHART_IS_LOADING: (state) => {
      return state.sisDashboardQueriesChartIsLoading;
    },
    GET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART_IS_LOADING: (state) => {
      return state.sisDashboardActivitiesProgressChartIsLoading;
    },
    GET_SIS_DASHBOARD_GRID_IS_LOADING: (state) => {
      return state.sisDashboardGridIsLoading;
    },
    GET_SIS_DASHBOARD_GRID_LAST_REQUEST: (state) => {
      return state.sisDashboardGridLastRequest;
    },
    GET_SIS_DASHBOARD_JOB_STATUS_LAST_REQUEST: (state) => {
      return state.sisDashboardJobStatusLastRequest;
    },
    GET_SIS_DASHBOARD_ACTIVITY_STATUS_LAST_REQUEST: (state) => {
      return state.sisDashboardActivityStatusLastRequest;
    },
    GET_SIS_DASHBOARD_EQUIPMENT_CHART_LAST_REQUEST: (state) => {
      return state.sisDashboardEquipmentChartLastRequest;
    },
    GET_SIS_DASHBOARD_CAUSE_CHART_LAST_REQUEST: (state) => {
      return state.sisDashboardCauseChartLastRequest;
    },
    GET_SIS_DASHBOARD_QUERIES_CHART_LAST_REQUEST: (state) => {
      return state.sisDashboardQueriesChartLastRequest;
    },
    GET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART_LAST_REQUEST: (state) => {
      return state.sisDashboardActivitiesProgressChartLastRequest;
    },
    GET_SIS_DASHBOARD_STATUS_TIMEOUT: (state) => {
      return state.updateDashboardStatusTimeout;
    },
  },
  mutations: {
    SET_SHOW_SIS_TESTING_DASHBOARD: (state, payload) => {
      state.showSisTestingDashboard = payload;
    },
    SET_SIS_DATAGRID_PROPERTIES_WITH_CHECK: (state, payload) => {
      state.sisDatagridPropertiesWithCheck = payload;
    },
    SET_DISPATCH_RESET_SIS_DASHBOARD_GRID: (state, payload) => {
      state.dispatchResetSisDashboardGrid = payload;
    },
    SET_SHOW_SIS_DASHBOARD_FILTERS_PANEL: (state, payload) => {
      state.showSisDashboardFiltersPanel = payload;
    },
    SET_SIS_DASHBOARD_PROPERTIES_FILTERS: (state, payload) => {
      state.propertiesFilters = payload;
    },
    SET_SIS_DASHBOARD_SELECTED_FILTER_PROPERTY: (state, payload) => {
      state.selectedFilterProperty = payload;
    },
    SET_FILTER_PANEL_SEARCH_TEXT: (state, payload) => {
      state.filterPanelSearchText = payload;
    },
    SET_SIS_DASHBOARD_JOB_STATUS: (state, payload) => {
      state.sisDashboardJobStatus = payload;
    },
    SET_SIS_DASHBOARD_ACTIVITY_STATUS: (state, payload) => {
      state.sisDashboardActivityStatus = payload;
    },
    SET_SIS_DASHBOARD_EQUIPMENT_CHART: (state, payload) => {
      state.sisDashboardEquipmentChart = payload;
    },
    SET_SIS_DASHBOARD_CAUSE_CHART: (state, payload) => {
      state.sisDashboardCauseChart = payload;
    },
    SET_SIS_DASHBOARD_QUERIES_CHART: (state, payload) => {
      state.sisDashboardQueriesChart = payload;
    },
    SET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART: (state, payload) => {
      state.sisDashboardActivitiesProgressChart = payload;
    },
    SET_SIS_DASHBOARD_SELECTED_DATE_RANGE_IN_DAYS: (state, payload) => {
      state.sisDashboardSelectedDateRangeInDays = payload;
    },
    SET_SIS_CHART_COLORS(state, payload) {
      state.sisChartColors = payload;
    },
    SET_SIS_DASHBOARD_SELECTED_UNITS(state, payload) {
      state.selectedUnits = payload;
    },
    SET_SIS_DASHBOARD_SELECTED_CLASSES(state, payload) {
      state.selectedClasses = payload;
    },
    SET_SIS_DASHBOARD_JOB_STATUS_IS_LOADING(state, payload) {
      state.sisDashboardJobStatusIsLoading = payload;
    },
    SET_SIS_DASHBOARD_ACTIVITY_STATUS_IS_LOADING(state, payload) {
      state.sisDashboardActivityStatusIsLoading = payload;
    },
    SET_SIS_DASHBOARD_EQUIPMENT_CHART_IS_LOADING(state, payload) {
      state.sisDashboardEquipmentChartIsLoading = payload;
    },
    SET_SIS_DASHBOARD_CAUSE_CHART_IS_LOADING(state, payload) {
      state.sisDashboardCauseChartIsLoading = payload;
    },
    SET_SIS_DASHBOARD_QUERIES_CHART_IS_LOADING(state, payload) {
      state.sisDashboardQueriesChartIsLoading = payload;
    },
    SET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART_IS_LOADING(state, payload) {
      state.sisDashboardActivitiesProgressChartIsLoading = payload;
    },
    SET_SIS_DASHBOARD_GRID_IS_LOADING(state, payload) {
      state.sisDashboardGridIsLoading = payload;
    },
    SET_SIS_DASHBOARD_GRID_LAST_REQUEST(state, payload) {
      state.sisDashboardGridLastRequest = payload;
    },
    SET_SIS_DASHBOARD_JOB_STATUS_LAST_REQUEST(state, payload) {
      state.sisDashboardJobStatusLastRequest = payload;
    },
    SET_SIS_DASHBOARD_ACTIVITY_STATUS_LAST_REQUEST(state, payload) {
      state.sisDashboardActivityStatusLastRequest = payload;
    },
    SET_SIS_DASHBOARD_EQUIPMENT_CHART_LAST_REQUEST(state, payload) {
      state.sisDashboardEquipmentChartLastRequest = payload;
    },
    SET_SIS_DASHBOARD_CAUSE_CHART_LAST_REQUEST(state, payload) {
      state.sisDashboardCauseChartLastRequest = payload;
    },
    SET_SIS_DASHBOARD_QUERIES_CHART_LAST_REQUEST(state, payload) {
      state.sisDashboardQueriesChartLastRequest = payload;
    },
    SET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART_LAST_REQUEST(state, payload) {
      state.sisDashboardActivitiesProgressChartLastRequest = payload;
    },
    SET_SIS_DASHBOARD_STATUS_TIMEOUT(state, payload) {
      state.updateDashboardStatusTimeout = payload;
    },
  },
  actions: {
    UPDATE_SIS_DASHBOARD_DATA({ commit, getters, dispatch }, payload) {
      let statusTimeout = getters.GET_SIS_DASHBOARD_STATUS_TIMEOUT;

      if (statusTimeout) {
        clearTimeout(statusTimeout);
        commit('SET_SIS_DASHBOARD_STATUS_TIMEOUT', null);
      }

      let timeout = setTimeout(() => {
        dispatch('GET_DASHBOARD_JOBS_STATUS').catch(() => {
          Vue.prototype.$dialog.notify.warning('Failed to get jobs status!');
        });
        dispatch('GET_DASHBOARD_ACTIVITIES_STATUS').catch(() => {
          Vue.prototype.$dialog.notify.warning('Failed to get activities status!');
        });
        dispatch('GET_DASHBOARD_EQUIPMENT_CHART_STATUS').catch(() => {
          Vue.prototype.$dialog.notify.warning('Failed to get equipment tags status!');
        });
        dispatch('GET_DASHBOARD_CAUSE_CHART_STATUS').catch(() => {
          Vue.prototype.$dialog.notify.warning('Failed to get cause tags status!');
        });
        dispatch('GET_DASHBOARD_QUERIES_CHART_STATUS').catch(() => {
          Vue.prototype.$dialog.notify.warning('Failed to get queries status!');
        });
        dispatch('GET_ACTIVITIES_PROGRESS_CHART_DATA').catch(() => {
          Vue.prototype.$dialog.notify.warning('Failed to get activities progress data!');
        });
        dispatch('GET_DASHBOARD_FILTERED_DATA_TAGS')
          .then((data) => {
            if (!data || data.length === 0) return;
            dispatch('ISOLATE_SIS_GRID_ROW_TAGS', data);
          })
          .catch(() => {
            Vue.prototype.$dialog.notify.warning('Failed to get filtered tags data!');
          });
      }, 500);

      commit('SET_SIS_DASHBOARD_STATUS_TIMEOUT', timeout);
    },
    GET_SIS_DASHBOARD_GRID_FILTERED_DATA({ commit, getters }, payload) {
      const baseUrl = store.state.parentAPI;
      const assetId = store.state.assetId;
      const jobStatus = getters.GET_SIS_DASHBOARD_SELECTED_JOB_STATUS;
      const activityStatus = getters.GET_SIS_DASHBOARD_SELECTED_ACTIVITY_STATUS;
      const equipmentStatus = getters.GET_SIS_DASHBOARD_SELECTED_EQUIPMENT_STATUS;
      const causeStatus = getters.GET_SIS_DASHBOARD_SELECTED_CAUSE_STATUS;
      const queryStatus = getters.GET_SIS_DASHBOARD_SELECTED_QUERIES_STATUS;
      const classes = getters.GET_SIS_DASHBOARD_SELECTED_CLASSES;
      const units = getters.GET_SIS_DASHBOARD_SELECTED_UNITS;

      return new Promise((resolve, reject) => {
        const unique = new Date().getTime();
        commit('SET_SIS_DASHBOARD_GRID_IS_LOADING', true);
        commit('SET_SIS_DASHBOARD_GRID_LAST_REQUEST', unique);

        HttpService.post({
          baseURL: baseUrl,
          url: `sub-job/sis/${assetId}`,
          data: {
            assetId: assetId,
            startIndex: payload.startIndex ?? 0,
            endIndex: payload.endIndex ?? 100,
            colId: payload.colId ?? 'Name',
            sort: payload.sort ?? 'ASC',
            filters: payload.filters ?? [],
            class: classes,
            unit: units,
            jobStatus: jobStatus,
            activityStatus: activityStatus,
            equipmentStatus: equipmentStatus,
            causeStatus: causeStatus,
            dateRangeInDays: getters.GET_SIS_DASHBOARD_SELECTED_DATE_RANGE_IN_DAYS,
            queryStatus: queryStatus,
          },
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch(reject)
          .finally(() => {
            commit('SET_SIS_DASHBOARD_GRID_IS_LOADING', false);
          });
      });
    },
    GET_DASHBOARD_ACTIVITIES_STATUS({ commit, getters }, payload) {
      const baseUrl = store.state.parentAPI;
      const assetId = store.state.assetId;
      return new Promise((resolve, reject) => {
        const unique = new Date().getTime();
        commit('SET_SIS_DASHBOARD_ACTIVITY_STATUS_IS_LOADING', true);
        commit('SET_SIS_DASHBOARD_ACTIVITY_STATUS_LAST_REQUEST', unique);

        HttpService.post({
          baseURL: baseUrl,
          url: `sub-job/sis/${assetId}/activities-status`,
          data: {
            assetId: assetId,
            jobStatus: getters.GET_SIS_DASHBOARD_SELECTED_JOB_STATUS,
            causeStatus: getters.GET_SIS_DASHBOARD_SELECTED_CAUSE_STATUS,
            equipmentStatus: getters.GET_SIS_DASHBOARD_SELECTED_EQUIPMENT_STATUS,
            dateRangeInDays: getters.GET_SIS_DASHBOARD_SELECTED_DATE_RANGE_IN_DAYS,
            queryStatus: getters.GET_SIS_DASHBOARD_SELECTED_QUERIES_STATUS,
            class: getters.GET_SIS_DASHBOARD_SELECTED_CLASSES,
            unit: getters.GET_SIS_DASHBOARD_SELECTED_UNITS,
          },
        })
          .then(({ data }) => {
            if (getters.GET_SIS_DASHBOARD_ACTIVITY_STATUS_LAST_REQUEST !== unique) return;

            getters.GET_SIS_DASHBOARD_ACTIVITY_STATUS.forEach((status) => {
              if (status.name === 'Not Started') {
                status.value = data.notStarted;
              } else if (status.name === 'Due') {
                status.value = data.due;
              } else if (status.name === 'Overdue') {
                status.value = data.overdue;
              } else if (status.name === 'In Progress') {
                status.value = data.inProgress;
              } else if (status.name === 'Suspended') {
                status.value = data.suspended;
              } else if (status.name === 'Completed') {
                status.value = data.completed;
              }
            });
            resolve(data);
          })
          .catch(reject)
          .finally(() => {
            commit('SET_SIS_DASHBOARD_ACTIVITY_STATUS_IS_LOADING', false);
          });
      });
    },
    GET_DASHBOARD_JOBS_STATUS({ commit, getters }, payload) {
      const baseUrl = store.state.parentAPI;
      const assetId = store.state.assetId;
      return new Promise((resolve, reject) => {
        const unique = new Date().getTime();
        commit('SET_SIS_DASHBOARD_JOB_STATUS_IS_LOADING', true);
        commit('SET_SIS_DASHBOARD_JOB_STATUS_LAST_REQUEST', unique);

        HttpService.post({
          baseURL: baseUrl,
          url: `sub-job/sis/${assetId}/jobs-status`,
          data: {
            assetId: assetId,
            activityStatus: getters.GET_SIS_DASHBOARD_SELECTED_ACTIVITY_STATUS,
            causeStatus: getters.GET_SIS_DASHBOARD_SELECTED_CAUSE_STATUS,
            equipmentStatus: getters.GET_SIS_DASHBOARD_SELECTED_EQUIPMENT_STATUS,
            dateRangeInDays: getters.GET_SIS_DASHBOARD_SELECTED_DATE_RANGE_IN_DAYS,
            queryStatus: getters.GET_SIS_DASHBOARD_SELECTED_QUERIES_STATUS,
            class: getters.GET_SIS_DASHBOARD_SELECTED_CLASSES,
            unit: getters.GET_SIS_DASHBOARD_SELECTED_UNITS,
          },
        })
          .then(({ data }) => {
            if (getters.GET_SIS_DASHBOARD_JOB_STATUS_LAST_REQUEST !== unique) return;

            getters.GET_SIS_DASHBOARD_JOB_STATUS.forEach((status) => {
              if (status.name === 'Not Started') {
                status.value = data.notStarted;
              } else if (status.name === 'In Progress') {
                status.value = data.inProgress;
              } else if (status.name === 'Completed') {
                status.value = data.completed;
              } else if (status.name === 'Canceled') {
                status.value = data.canceled;
              }
            });
            resolve(data);
          })
          .catch(reject)
          .finally(() => {
            commit('SET_SIS_DASHBOARD_JOB_STATUS_IS_LOADING', false);
          });
      });
    },
    GET_DASHBOARD_EQUIPMENT_CHART_STATUS({ commit, getters }, payload) {
      const baseUrl = store.state.parentAPI;
      const assetId = store.state.assetId;
      return new Promise((resolve, reject) => {
        const unique = new Date().getTime();
        commit('SET_SIS_DASHBOARD_EQUIPMENT_CHART_IS_LOADING', true);
        commit('SET_SIS_DASHBOARD_EQUIPMENT_CHART_LAST_REQUEST', unique);

        HttpService.post({
          baseURL: baseUrl,
          url: `sub-job/sis/${assetId}/equipment-status`,
          data: {
            assetId: assetId,
            jobStatus: getters.GET_SIS_DASHBOARD_SELECTED_JOB_STATUS,
            activityStatus: getters.GET_SIS_DASHBOARD_SELECTED_ACTIVITY_STATUS,
            causeStatus: getters.GET_SIS_DASHBOARD_SELECTED_CAUSE_STATUS,
            dateRangeInDays: getters.GET_SIS_DASHBOARD_SELECTED_DATE_RANGE_IN_DAYS,
            queryStatus: getters.GET_SIS_DASHBOARD_SELECTED_QUERIES_STATUS,
            class: getters.GET_SIS_DASHBOARD_SELECTED_CLASSES,
            unit: getters.GET_SIS_DASHBOARD_SELECTED_UNITS,
          },
        })
          .then(({ data }) => {
            if (getters.GET_SIS_DASHBOARD_EQUIPMENT_CHART_LAST_REQUEST !== unique) return;

            getters.GET_SIS_DASHBOARD_EQUIPMENT_CHART.forEach((status) => {
              if (status.label === 'Ready') {
                status.value = data.ready;
              } else if (status.label === 'Not Ready') {
                status.value = data.notReady;
              } else if (status.label === 'Overdue') {
                status.value = data.overdue;
              }
            });
            resolve(data);
          })
          .catch(reject)
          .finally(() => {
            commit('SET_SIS_DASHBOARD_EQUIPMENT_CHART_IS_LOADING', false);
          });
      });
    },
    GET_DASHBOARD_CAUSE_CHART_STATUS({ commit, getters }, payload) {
      const baseUrl = store.state.parentAPI;
      const assetId = store.state.assetId;
      return new Promise((resolve, reject) => {
        const unique = new Date().getTime();
        commit('SET_SIS_DASHBOARD_CAUSE_CHART_IS_LOADING', true);
        commit('SET_SIS_DASHBOARD_CAUSE_CHART_LAST_REQUEST', unique);

        HttpService.post({
          baseURL: baseUrl,
          url: `sub-job/sis/${assetId}/cause-status`,
          data: {
            assetId: assetId,
            jobStatus: getters.GET_SIS_DASHBOARD_SELECTED_JOB_STATUS,
            activityStatus: getters.GET_SIS_DASHBOARD_SELECTED_ACTIVITY_STATUS,
            equipmentStatus: getters.GET_SIS_DASHBOARD_SELECTED_EQUIPMENT_STATUS,
            dateRangeInDays: getters.GET_SIS_DASHBOARD_SELECTED_DATE_RANGE_IN_DAYS,
            queryStatus: getters.GET_SIS_DASHBOARD_SELECTED_QUERIES_STATUS,
            class: getters.GET_SIS_DASHBOARD_SELECTED_CLASSES,
            unit: getters.GET_SIS_DASHBOARD_SELECTED_UNITS,
          },
        })
          .then(({ data }) => {
            if (getters.GET_SIS_DASHBOARD_CAUSE_CHART_LAST_REQUEST !== unique) return;

            getters.GET_SIS_DASHBOARD_CAUSE_CHART.forEach((status) => {
              if (status.label === 'Ready') {
                status.value = data.ready;
              } else if (status.label === 'Not Ready') {
                status.value = data.notReady;
              } else if (status.label === 'In Progress') {
                status.value = data.inProgress;
              } else if (status.label === 'Overdue') {
                status.value = data.overdue;
              }
            });
            resolve(data);
          })
          .catch(reject)
          .finally(() => {
            commit('SET_SIS_DASHBOARD_CAUSE_CHART_IS_LOADING', false);
          });
      });
    },
    GET_DASHBOARD_QUERIES_CHART_STATUS({ commit, getters }, payload) {
      const baseUrl = store.state.parentAPI;
      const assetId = store.state.assetId;
      return new Promise((resolve, reject) => {
        let unique = new Date().getTime();
        commit('SET_SIS_DASHBOARD_QUERIES_CHART_IS_LOADING', true);
        commit('SET_SIS_DASHBOARD_QUERIES_CHART_LAST_REQUEST', unique);

        HttpService.post({
          baseURL: baseUrl,
          url: `sub-job/sis/${assetId}/queries-status`,
          data: {
            assetId: assetId,
            jobStatus: getters.GET_SIS_DASHBOARD_SELECTED_JOB_STATUS,
            activityStatus: getters.GET_SIS_DASHBOARD_SELECTED_ACTIVITY_STATUS,
            causeStatus: getters.GET_SIS_DASHBOARD_SELECTED_CAUSE_STATUS,
            equipmentStatus: getters.GET_SIS_DASHBOARD_SELECTED_EQUIPMENT_STATUS,
            dateRangeInDays: getters.GET_SIS_DASHBOARD_SELECTED_DATE_RANGE_IN_DAYS,
            class: getters.GET_SIS_DASHBOARD_SELECTED_CLASSES,
            unit: getters.GET_SIS_DASHBOARD_SELECTED_UNITS,
          },
        })
          .then(({ data }) => {
            if (getters.GET_SIS_DASHBOARD_QUERIES_CHART_LAST_REQUEST !== unique) return;

            getters.GET_SIS_DASHBOARD_QUERIES_CHART.forEach((status) => {
              if (status.label === 'Raised') {
                status.value = data.raised;
              } else if (status.label === 'Answered') {
                status.value = data.answered;
              } else if (status.label === 'Closed') {
                status.value = data.closed;
              }
            });
            resolve(data);
          })
          .catch(reject)
          .finally(() => {
            commit('SET_SIS_DASHBOARD_QUERIES_CHART_IS_LOADING', false);
          });
      });
    },
    GET_ACTIVITIES_PROGRESS_CHART_DATA({ commit, getters }, payload) {
      const baseUrl = store.state.parentAPI;
      const assetId = store.state.assetId;
      const jobStatus = getters.GET_SIS_DASHBOARD_SELECTED_JOB_STATUS;
      const activityStatus = getters.GET_SIS_DASHBOARD_SELECTED_ACTIVITY_STATUS;
      const equipmentStatus = getters.GET_SIS_DASHBOARD_SELECTED_EQUIPMENT_STATUS;
      const causeStatus = getters.GET_SIS_DASHBOARD_SELECTED_CAUSE_STATUS;
      const queryStatus = getters.GET_SIS_DASHBOARD_SELECTED_QUERIES_STATUS;
      const classes = getters.GET_SIS_DASHBOARD_SELECTED_CLASSES;
      const units = getters.GET_SIS_DASHBOARD_SELECTED_UNITS;

      return new Promise((resolve, reject) => {
        const unique = new Date().getTime();
        commit('SET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART_IS_LOADING', true);
        commit('SET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART_LAST_REQUEST', unique);

        HttpService.post({
          baseURL: baseUrl,
          url: `sub-job/sis/${assetId}/activities-progress`,
          data: {
            assetId: assetId,
            jobStatus: jobStatus,
            activityStatus: activityStatus,
            equipmentStatus: equipmentStatus,
            causeStatus: causeStatus,
            dateRangeInDays: getters.GET_SIS_DASHBOARD_SELECTED_DATE_RANGE_IN_DAYS,
            queryStatus: queryStatus,
            class: classes,
            unit: units,
          },
        })
          .then(({ data }) => {
            if (data.length === 0) {
              commit('SET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART', {
                actualStartDates: [],
                plannedStartDates: [],
                forecastDates: [],
              });
              resolve(data);
              return;
            }

            let actualStartDates = [];
            let plannedStartDates = [];
            let forecastDates = [];

            data.forEach((activity) => {
              actualStartDates.push({
                x: activity.name,
                y: new Date(activity.actualStartDate).getTime(),
              });
              plannedStartDates.push({
                x: activity.name,
                y: new Date(activity.plannedStartDate).getTime(),
              });
              forecastDates.push({
                x: activity.name,
                y: new Date(activity.plannedEndDate).getTime(),
              });

              commit('SET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART', {
                actualStartDates: actualStartDates,
                plannedStartDates: plannedStartDates,
                forecastDates: forecastDates,
              });
            });

            resolve(data);
          })
          .catch(reject)
          .finally(() => {
            commit('SET_SIS_DASHBOARD_ACTIVITIES_PROGRESS_CHART_IS_LOADING', false);
          });
      });
    },
    REQUEST_SIS_DASHBOARD_PROPERTIES_FILTERS({ commit, state, getters }) {
      const baseUrl = store.state.parentAPI;
      const assetId = store.state.assetId;

      return new Promise((resolve, reject) => {
        HttpService.post({
          baseURL: baseUrl,
          url: `sub-job/sis/${assetId}/filters`,
          data: {
            assetId: assetId,
            jobStatus: state.sisDashboardJobStatus.filter((s) => s.isSelected).map((s) => s.name),
            activityStatus: state.sisDashboardActivityStatus
              .filter((s) => s.isSelected)
              .map((s) => s.name),
            equipmentStatus: state.sisDashboardEquipmentChart
              .filter((s) => s.isSelected)
              .map((s) => s.label),
            causeStatus: state.sisDashboardCauseChart
              .filter((s) => s.isSelected)
              .map((s) => s.label),
            dateRangeInDays: state.sisDashboardSelectedDateRangeInDays,
            queryStatus: state.sisDashboardQueriesChart
              .filter((s) => s.isSelected)
              .map((s) => s.label),
          },
        })
          .then(({ data }) => {
            let filters = getters.GET_SIS_DASHBOARD_PROPERTIES_FILTERS;
            filters.forEach((filter) => {
              if (filter.property === 'customFieldA') {
                filter.values =
                  data.class.length > 0
                    ? [
                        { value: 'Select All', isSelected: false },
                        ...data.class?.map((a) => ({ value: a, isSelected: false })),
                      ]
                    : [];
              } else if (filter.property === 'customFieldB') {
                filter.values =
                  data.unit.length > 0
                    ? [
                        { value: 'Select All', isSelected: false },
                        ...data.unit?.map((a) => ({ value: a, isSelected: false })),
                      ]
                    : [];
              }
            });
            commit('SET_SIS_DASHBOARD_PROPERTIES_FILTERS', filters);
            resolve(data);
          })
          .catch(reject);
      });
    },
    TOGGLE_SHOW_SIS_DASHBOARD_FILTERS_PANEL({ commit, getters }) {
      commit('SET_SHOW_SIS_DASHBOARD_FILTERS_PANEL', !getters.GET_SHOW_SIS_DASHBOARD_FILTERS_PANEL);
    },
    GET_DASHBOARD_FILTERED_DATA_TAGS({ commit, getters, dispatch }) {
      const baseUrl = store.state.parentAPI;
      const assetId = store.state.assetId;
      const jobStatus = getters.GET_SIS_DASHBOARD_SELECTED_JOB_STATUS;
      const activityStatus = getters.GET_SIS_DASHBOARD_SELECTED_ACTIVITY_STATUS;
      const equipmentStatus = getters.GET_SIS_DASHBOARD_SELECTED_EQUIPMENT_STATUS;
      const causeStatus = getters.GET_SIS_DASHBOARD_SELECTED_CAUSE_STATUS;
      const queryStatus = getters.GET_SIS_DASHBOARD_SELECTED_QUERIES_STATUS;
      const classes = getters.GET_SIS_DASHBOARD_SELECTED_CLASSES;
      const units = getters.GET_SIS_DASHBOARD_SELECTED_UNITS;

      if (
        classes.length === 0 &&
        units.length === 0 &&
        (jobStatus.length === 0 || jobStatus.length === 4) &&
        (activityStatus.length === 0 || activityStatus.length === 6) &&
        (equipmentStatus.length === 0 || equipmentStatus.length === 3) &&
        (queryStatus.length === 0 || queryStatus.length === 3) &&
        (causeStatus.length === 0 || causeStatus.length === 4)
      )
        return Promise.resolve([]);

      return new Promise((resolve, reject) => {
        HttpService.post({
          baseURL: baseUrl,
          url: `sub-job/sis/${assetId}/filtered-tags`,
          data: {
            assetId: assetId,
            jobStatus: jobStatus,
            activityStatus: activityStatus,
            equipmentStatus: equipmentStatus,
            causeStatus: causeStatus,
            dateRangeInDays: getters.GET_SIS_DASHBOARD_SELECTED_DATE_RANGE_IN_DAYS,
            queryStatus: queryStatus,
            class: classes,
            unit: units,
          },
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch(reject);
      });
    },
    ISOLATE_SIS_GRID_ROW_TAGS({ commit, getters, dispatch }, tags) {
      if (!store.state.viewer?.model) {
        Vue.prototype.$dialog.notify.warning('Please open the 3D model!');
        return;
      }

      let list = tags.map((tag) => {
        return {
          id: tag.guid,
          status: tag.status,
        };
      });

      if (!list?.length) {
        Vue.prototype.$dialog.notify.warning('No valid tags found!');
        return;
      }

      dispatch(
        'GET_BASE_TAGS_BY_IDS',
        list.map((tag) => tag.id),
      )
        .then((data) => {
          if (!data || data.length == 0) {
            Vue.prototype.$dialog.notify.warning('No valid tags found!');

            return;
          }

          let themedDbIds = store.getters['GET_THEMED_DB_IDS'];
          let needToReset = store.state.isGhostingOn && !store.state.isGhostingWireframe;

          if (!!themedDbIds?.length && needToReset) clearThemingColors(store.state.viewer);

          let dbIdsIsolate = [];

          data.forEach((tag) => {
            let dbIds = tag.children.map((t) => t.dbId) ?? [];
            dbIdsIsolate.push(...dbIds);

            let status = list.find((l) => l.id == tag.id)?.status;

            if (!status) return;

            let color = getters.GET_SIS_CHART_COLORS[status];

            if (!color) return;

            color = new THREE.Color(color);
            color = new THREE.Vector4(color.r, color.g, color.b, 1);
            setPermeativeElementsTheme(dbIds, color);
          });

          store.commit('SET_THEMED_DB_IDS', dbIdsIsolate);

          store.state.forgeService
            .getMainExtension()
            .isolateDbIds(dbIdsIsolate, store.state.viewer.model);
        })
        .catch(debugError);
    },
  },
};
